import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { catchError, throwError } from "rxjs";
import { HttpErrorResponse, HttpInterceptorFn, HttpStatusCode } from "@angular/common/http";

import { ToastService } from "@azm/core/services/toast/toast.service";
import { IApiResponse } from "@azm/core/interfaces/response";
import { isUnauthorizedHttpError } from "@azm/core/utilities/http-unauthorized";

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
	const router = inject(Router);
	const toast = inject(ToastService);

	return next(req).pipe(
		catchError((error: unknown) => {
			if (!(error instanceof HttpErrorResponse)) {
				return throwError(() => error);
			}

			const httpErrorResponse = error;

			if (!httpErrorResponse.status) {
				toast.backendError("alert.server_not_responding");

				return throwError(() => httpErrorResponse);
			}

			if (isUnauthorizedHttpError(httpErrorResponse)) return throwError(() => httpErrorResponse);

			if (httpErrorResponse.status === HttpStatusCode.Forbidden) {
				toast.backendError("alert.forbidden");

				return throwError(() => httpErrorResponse);
			}

			const response = httpErrorResponse.error as IApiResponse<unknown>;
			if (!response) {
				toast.backendError("alert.server_not_responding");

				return throwError(() => httpErrorResponse);
			}

			if (response.errors?.length) {
				response.errors.forEach((error: string) => toast.backendError(error?.trim() || "alert.unhandled_error"));
			} else if (response.statusCode === HttpStatusCode.Forbidden || httpErrorResponse.status === HttpStatusCode.Forbidden) {
				router.navigateByUrl("/error/403");
			} else if (!response.success || !response.statusCode.toString().startsWith("2")) {
				if (req.headers.get("show-alert") === "true") {
					const headerMessage = req.headers.get("error-alert-message")?.trim();
					toast.backendError(headerMessage || "alert.unhandled_error");
				}
			}

			return throwError(() => httpErrorResponse);
		}),
	);
};
